import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Send } from 'lucide-react';
import { getToken } from '../../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/maitres-ouvrage/envois`;
const frDT = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—');

/** Administration : attestations envoyées par les membres à leurs maîtres d'ouvrage. */
export default function EnvoisAttestationsMO() {
  const [membre, setMembre] = useState('');
  const [mois, setMois] = useState('');
  const [data, setData] = useState(null);
  const charger = useCallback(() => {
    setData(null);
    axios.get(API, { params: { membre, mois }, headers: { Authorization: `Bearer ${getToken()}` } })
      .then((r) => setData(r.data)).catch(() => setData({ envois: [], total: 0 }));
  }, [membre, mois]);
  useEffect(() => { const t = setTimeout(charger, 300); return () => clearTimeout(t); }, [charger]);

  return (
    <div className="space-y-4" data-testid="envois-attestations-mo">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-bold text-[#0a3d62]"><Send className="h-5 w-5" /> Attestations envoyées aux maîtres d'ouvrage</h2>
        <p className="text-xs text-slate-500">Envois faits par les membres depuis leur carnet « Mes maîtres d'ouvrage »</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <input value={membre} onChange={(e) => setMembre(e.target.value)} placeholder="Membre (raison sociale ou SIRET)"
          className="h-9 w-72 rounded-lg border border-slate-200 px-3 text-sm" data-testid="envois-filtre-membre" />
        <input type="month" value={mois} onChange={(e) => setMois(e.target.value)} className="h-9 rounded-lg border border-slate-200 px-3 text-sm" data-testid="envois-filtre-mois" />
        {data && <span className="self-center text-xs text-slate-500" data-testid="envois-total">{data.total} envoi(s)</span>}
      </div>
      {!data ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200">
          <table className="w-full min-w-[900px] text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
              <tr><th className="p-2">Date</th><th className="p-2">Membre</th><th className="p-2">Chantier</th><th className="p-2">Maître d'ouvrage</th><th className="p-2">Envoyé à</th><th className="p-2">Lecture</th><th className="p-2">Par</th></tr>
            </thead>
            <tbody>
              {data.envois.map((e, i) => (
                <tr key={`${e.souscription_id}-${i}`} className="border-t border-slate-100" data-testid={`envoi-ligne-${i}`}>
                  <td className="whitespace-nowrap p-2">{frDT(e.at)}</td>
                  <td className="p-2 font-semibold text-[#0a3d62]">{e.membre}<span className="block text-[10px] font-normal text-slate-400">{e.numero_police}</span></td>
                  <td className="p-2 text-slate-600">{e.chantier || '—'}</td>
                  <td className="p-2">{e.maitre_ouvrage || '—'}</td>
                  <td className="p-2 text-slate-600">{e.destinataire}</td>
                  <td className="whitespace-nowrap p-2 text-xs" data-testid={`envoi-lecture-${i}`}>
                    {e.ouvert_at ? <span className="font-semibold text-emerald-700">Ouvert le {frDT(e.ouvert_at)}</span>
                      : <span className="text-slate-400">{e.suivi ? 'Pas encore ouvert (ou images bloquées)' : 'Non suivi'}</span>}
                  </td>
                  <td className="p-2 text-xs text-slate-500">{e.par}</td>
                </tr>
              ))}
              {!data.envois.length && <tr><td colSpan={7} className="p-6 text-center text-slate-400">Aucun envoi</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
